/*
 * @Author: hehaishen
 * @Date: 2019-05-05 14:34:58
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2019-12-24 18:08:33
 * @Description: 
 */
const routerArr = [
    {
        path: 'iot',
        component: (resolve) => require(["page/iot/index"], resolve),
        meta: { show: '1110', title: '物联应用', },
    },
    {
        path: 'iot/deviceManage',
        component: (resolve) => require(["page/iot/deviceManage.vue"], resolve),
        meta: { show: '1110', title: '物联应用', }
    },
];

export default routerArr;


// WEBPACK FOOTER //
// ./src/container/pages/iot/_res.js